<template>
  <div id="user-auth-questions-edit" class="row" v-if="loaded">
    <form id="edit-user-auth-questions-form" class="small-12 medium-8 columns" @submit.prevent="submitForm">
      <table>
        <thead>
          <tr>
            <th>{{ 'Question' }}</th>
            <th>{{ 'Answer' }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="(v, k) in questions" :key="k">
          <td><input type="text" v-model="questions[k].q" /></td>
          <td><input type="text" v-model="questions[k].a" :placeholder="questions[k].exists ? '**********' : ''" /></td>
          <td><a class="small alert button" @click.prevent="removeQuestion(k)"><i class="icon icon-bin"></i></a></td>
        </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="3" class="text-center">
              <a class="success button" @click.prevent="addQuestion()"><i class="icon icon-plus"></i> Add</a>
            </td>
          </tr>
        </tfoot>
      </table>

      <p class="help-text">{{ 'These questions will be used during account recovery in case of password loss. Provide at least three questions. Keep answers to existing questions empty to preserve current answers.'|t }}</p>

      <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" />
    </form>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'QuestionsForm',
    props: {
      user_id: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        loaded: false,
        questions: [],
      }
    },
    computed: {
      computed: {
        isAdmin() {
          return this.$store.getters['auth/isAdmin']
        },
      },
    },
    created() {
      // TODO: check if user matches provided user_id

      api.getUserAuthQuestions(
        {user_id: this.user_id},
        data => {
          this.loaded = true;
          this.questions = [];
          for (let i in data.questions) {
            this.questions.push({q: data.questions[i], a: "", exists: true})
          }
        }
      )
    },
    methods: {
      submitForm() {
        let request = {
          user_id: this.user_id,
          questions: {},
        };

        for (let i in this.questions) {
          let q = this.questions[i];
          if (q.q.length > 0) {
            request.questions[q.q] = q.a;
          }
        }

        api.changeUserAuthQuestions(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "User %d has been updated.",
              args: [data.id]
            }, {root: true});
            if (this.isAdmin) {
              router.push({name: 'user.collection'});
            } else {
              router.push('/');
            }
          }
        )
      },
      addQuestion() {
        this.questions.push({q: "", a: "", exists: false})
      },
      removeQuestion(i) {
        this.questions.splice(i, 1)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/user/QuestionsForm.vue